module.exports = __webpack_public_path__ + "vu.svg?23d9b689d94733497f4e5be5004f1892";